const firebaseConfig = {
  apiKey: "AIzaSyC4GlAD2eSyoFe3By1m9tHl2HwVRfuCkSM",
  authDomain: "godfathers-creative-agency.firebaseapp.com",
  databaseURL: "https://godfathers-creative-agency.firebaseio.com",
  projectId: "godfathers-creative-agency",
  storageBucket: "godfathers-creative-agency.appspot.com",
  messagingSenderId: "487417620787",
  appId: "1:487417620787:web:e0337f587f4ba78fe77646"
};
export default firebaseConfig;